import { get } from 'lodash';
import Axios, { validateStatus } from 'util/service';

/**
 * Return a general error message in case there are no given errors
 * @param {object} data - The payload
 * @param {number} status - The status code
 * @param {string} statusText - A text describing the status code
 * @return {string[]} A list of general errors
 */
export function createGeneralErrors({ data, status, statusText }) {
    const errors = get(data, 'messages.error', []);

    if (!errors.length) {
        return [`${ status } - ${ statusText }`];
    }

    return errors;
}

/**
 * Create a new form submission request
 * @param {HTMLElement} form - The form element
 * @param {string} url - The form submission endpoint
 * @param {function[]} postProcessors - A list of data post processors
 * @return {Promise} The request
 */
export function createSubmissionRequest(form, url, postProcessors) {
    const formData = postProcessors.reduce((acc, postProcessor) => postProcessor(acc), new FormData(form));

    return Axios.post(url, formData, { validateStatus });
}
